const thirdParty = {
  thirdParty: {
    pageHeader: '3rd Party Reporting',
    clearState: 'Clear State',
    register: 'Register',
    systemRegistrationSummary: 'System Registration Summary',
    registrationProgress: '%{registration_in_progress} In Progress',
    registrationComplete: '%{registration_complete} Complete',
    thirdPartyLogin: 'Please login as the site owner to manage your PowerDash account',
    thirdPartyInvalidURI: 'The URI requested is invalid or the resource requested, such as a system, does not exist.'
  }
};

export default thirdParty;
